module.exports = __webpack_public_path__ + "static/media/Marina.419a0ac6.jpg";